// extracted by mini-css-extract-plugin
module.exports = {"giftCardPage":"giftcard_giftCardPage__NhC4j","col":"giftcard_col__t6GPi","container":"giftcard_container__6F4_H","img":"giftcard_img__EU3g3"};